// form_text_86
const inputs = document.querySelectorAll(
	'.bx-soa-customer-field--PHONE input, ' +
		'input[name="form_text_101"], ' +
		'input[name="form_text_105"], ' +
		'input[name="form_text_112"], ' +
		'input[name="form_text_82"], ' +
		'input[name="form_text_86"], ' +
		'input[name="form_text_73"]'
);

if (inputs.length > 0) {
	import(/* webpackChunkName: "intl-tel-input" */ 'intl-tel-input').then((intlTelInput) => {
		// wait until the load event so we don't block any other requests e.g. the flags image
		window.addEventListener('load', () => {
			import(/* webpackChunkName: "tel-utils" */ 'intl-tel-input/build/js/utils');
		});

		inputs.forEach((input) => {
			const iti = intlTelInput.default(input, {
				preferredCountries: ['DE', 'GB', 'PL', 'RU'],
				nationalMode: false,
				formatOnDisplay: true,
				initialCountry: 'auto',
				// geoIpLookup: function (success, failure) {
				// 	console.log('lookup');
				// 	$.get('https://ipinfo.io', function () {}, 'jsonp').always(function (resp) {
				// 		console.log(resp);
				// 		var countryCode = resp && resp.country ? resp.country : '';
				// 		console.log(countryCode);
				// 		success(countryCode);
				// 	});
				// },
			});

			function formatIntlTelInput() {
				if (typeof intlTelInputUtils !== 'undefined') {
					// utils are lazy loaded, so must check
					var currentText = iti.getNumber(intlTelInputUtils.numberFormat.E164);
					if (typeof currentText === 'string') {
						// sometimes the currentText is an object :)
						iti.setNumber(currentText); // will autoformat because of formatOnDisplay=true
					}
				}
			}

			input.addEventListener('keyup', formatIntlTelInput);
			input.addEventListener('change', formatIntlTelInput);
		});
	});
}
